(function ($, Drupal) {
  Drupal.behaviors.confirmCode = {
    attach: function (context, settings) {
      let btnContinuarStep5 = document.querySelector(
        '.step-5.btn-continuar input[data-drupal-selector="edit-next"]'
      );

      let confirmCode = document.querySelector(
        'input[data-drupal-selector="edit-code-confirm"]'
      );

      let editCodeIngresar = document.querySelector('input[data-drupal-selector="edit-code"]')

      let dataUpdateForm = document.querySelector('.data-update-form');
      let stepEnd = document.querySelector('.step-end');
      let header = document.querySelector('header');
      let alertError = document.querySelector('[data-drupal-messages] [aria-label*="error"]');

      if (btnContinuarStep5 != null) {
        let layoutContentStep5 = once('layout', context.querySelector('.layout-content'));
        let divError = document.createElement('div');
        divError.classList.add('mensaje-error-codigo');
        divError.innerHTML = "por favor ingrese un código.";

        if (confirmCode.classList.contains("error")) {
          confirmCode.closest(".data-update-form").classList.add("error-code");
          header.classList.add('error')
        } else {
          confirmCode.closest(".data-update-form").classList.remove("error-code");
          header.classList.remove('error')
        }

      }

      if(editCodeIngresar != null){
        if (editCodeIngresar.classList.contains('error')) {
          editCodeIngresar.closest(".data-update-form").classList.add("error-code");
          header.classList.add('error')
        } else {
          editCodeIngresar.closest(".data-update-form").classList.remove("error-code");
          header.classList.remove('error')

        }
      }

      //remove error alert home
      if (dataUpdateForm != null) {
        if (!dataUpdateForm.classList.contains('ajax-submit-prevented') && alertError != null) {
          alertError.classList.add('hide-alert');
          header.classList.remove('error');
        }
      }

      if (stepEnd != null && alertError != null) {
        alertError.classList.add('hide-alert');
        header.classList.remove('error');
      }

      once('download-certificate-trigger', '#download-certificate-btn', context)
        .forEach((element) => {
          if (document.createTouch) {
            let touchEvent = document.createEvent("TouchEvent");
            let param = {
              type: "touchstart",
              canBubble: true,
              cancelable: true,
              view: window,
              detail: 0,
              screenX: 0,
              screenY: 0,
              clientX: 0,
              clientY: 0,
              ctrlKey: false,
              altKey: false,
              shiftKey: false,
              metaKey: false,
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              scale: 0,
              rotation: 0,
              touchItem: 0
            };
            touchEvent.initTouchEvent(
              param.touchItem,
              param.touchItem,
              param.touchItem,
              param.type,
              param.view,
              param.screenX,
              param.screenY,
              param.clientX,
              param.clientY,
              param.ctrlKey,
              param.altKey,
              param.shiftKey,
              param.metaKey
            );
            element.dispatchEvent(touchEvent);
          } else {
            element.click();
          }

        });
    },
  };
})(jQuery, Drupal);
